
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flag/claude-engineer-2026/[variant]/catalog",
      function () {
        return require("private-next-pages/flag/claude-engineer-2026/[variant]/catalog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flag/claude-engineer-2026/[variant]/catalog"])
      });
    }
  